const getEither = <T, K>(field1: T | undefined | null, field2: K): T | K => {
    return field1 || field2;
};

export default getEither;
